import React from 'react'
import { SUI } from 'shared/ui'
import themeVars from 'ui_theme/site/globals/site.variables'
import Search from 'components/App/DesktopView/Layout/TicketListHeader/Search'
import NewTicketButton from './NewTicketButton'

export default function SearchBar() {
  return (
    <SUI>
      <div
        css={`
          display: flex;
          justify-content: space-between;
          padding-top: ${themeVars.mini};
          padding-bottom: ${themeVars.mini};
          padding-left: ${themeVars.big};
          padding-right: ${themeVars.large};
          background-color: ${themeVars.brightSuperDark};
          border-bottom: 1px solid ${themeVars.dust};
        `}
      >
        <Search
          css={`
            flex-grow: 1;
            max-width: 582px;

            &&& [class*='searchBox_input__'] {
              padding: 6px;
              padding-left: 28px;
              border: 1px solid ${themeVars.dust};
              border-radius: ${themeVars.defaultBorderRadius};

              &::placeholder {
                color: ${themeVars.dark};
              }
            }

            & [class*='searchBox_backIcon__'] {
              left: 8px;
            }

            & [class*='SearchSuggestions__'] {
              top: 26px;
            }
          `}
        />

        <NewTicketButton
          css={`
            margin-left: 12px;
          `}
        />
      </div>
    </SUI>
  )
}
